import type { FC, KeyboardEvent } from "react";

import { CheckoutV2LoyaltyChoice } from "@jti/store/slices/checkoutV2Slice";
import { FormattedPrice, I18n, useTranslations } from "@jti/ui";

import { useCurrency } from "@checkout-v2/shared/hooks/useCurrency";

import type { LoyaltyPreviewInfo } from "../PaymentMethodsSectionPreview/PaymentMethodsSectionPreview.types";

import styles from "./LoyaltyPreviewDescription.module.scss";

type LoyaltyPreviewDescriptionProps = {
  loyaltyInfo?: LoyaltyPreviewInfo;
  isRedeemVisible?: boolean;
};

export const LoyaltyPreviewDescription: FC<LoyaltyPreviewDescriptionProps> = ({
  loyaltyInfo,
  isRedeemVisible = true,
}) => {
  const currency = useCurrency();
  const { __ } = useTranslations();
  const userPoints = loyaltyInfo?.userPoints;
  const onRedeem = loyaltyInfo?.onRedeem;

  const handleRedeemKeyDown = (event: KeyboardEvent<HTMLSpanElement>) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    event.preventDefault();
    loyaltyInfo?.onRedeem?.();
  };

  if (loyaltyInfo?.choice === CheckoutV2LoyaltyChoice.COLLECT) {
    return (
      <>
        <span className={styles.points}>
          <I18n t="cart.checkout.loyalty.preview.points">{loyaltyInfo.points}</I18n>
        </span>
        {isRedeemVisible && userPoints !== undefined && userPoints > 0 && onRedeem && (
          <span className={styles.redeemQuestion}>
            <I18n t="cart.checkout.loyalty.preview.redeemQuestion">
              <span
                className={styles.redeemButton}
                role="button"
                tabIndex={0}
                onClick={onRedeem}
                onKeyDown={handleRedeemKeyDown}
              >
                {__("cart.checkout.loyalty.preview.redeemButton", [userPoints.toString()])}
              </span>
            </I18n>
          </span>
        )}
      </>
    );
  }

  return (
    <I18n t="cart.checkout.loyalty.preview.voucher">
      <FormattedPrice value={loyaltyInfo?.voucherPrice ?? 0} currency={currency ?? ""} />
      {loyaltyInfo?.points}
    </I18n>
  );
};
